(function(){
  var root = document.getElementById('kc');
  if (!root) return;
  var CFG = JSON.parse(document.getElementById('kc-cfg').textContent);
  var T = CFG.t;
  var R = CFG.root || '';
  var DATA = [], BYID = {}, FOTOS = [];
  var PH = 'data:image/svg+xml;utf8,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 160"><rect x="28" y="14" width="64" height="132" rx="10" fill="#fff" stroke="#c5cee0" stroke-width="3"/><rect x="38" y="28" width="44" height="34" rx="4" fill="#e6ebf5"/><circle cx="60" cy="88" r="8" fill="#e6ebf5"/><rect x="44" y="108" width="32" height="10" rx="5" fill="#e6ebf5"/></svg>');
  var AVISO = '<svg viewBox="0 0 24 24" width="30" height="30" aria-hidden="true" style="flex:none"><path d="M12 2.5 1.5 21h21L12 2.5z" fill="#f59e0b" stroke="#f59e0b" stroke-width="1.5" stroke-linejoin="round"/><rect x="11" y="9" width="2" height="6.5" rx="1" fill="#fff"/><circle cx="12" cy="18" r="1.25" fill="#fff"/></svg>';

  function q(s){ return root.querySelector(s); }
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  function norm(s){ return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, ' ').trim(); }
  function V(s){ return (T.v && T.v[s]) || s || ''; }
  function fmt(s, o){ return String(s).replace(/\{(\w+)\}/g, function(_, k){ return o[k]; }); }
  function fotoUrl(m){ return m.foto ? CFG.base + m.foto : PH; }
  function link(p){ return R + p; }
  var IMGERR = ' onerror="this.onerror=null;this.src=\'' + PH + '\'"';
  var TIT = ' style="font-family:Georgia,\'Times New Roman\',serif;font-size:19px;font-weight:700;line-height:1.3;margin:0 0 6px"';

  root.querySelectorAll('[data-t]').forEach(function(el){ var v = T[el.getAttribute('data-t')]; if (typeof v === 'string') el.textContent = v; });
  var inp = q('#kc-q');
  inp.placeholder = T.ph;

  /* ---------- vista y navegacion ---------- */
  function params(){ return new URLSearchParams(location.search); }
  function depth(){ return (history.state && history.state.kcd) || 0; }
  function nav(p, replace){
    var u = new URL(location.href);
    ['m','solicitar','q','rev'].forEach(function(k){ u.searchParams.delete(k); });
    Object.keys(p).forEach(function(k){ if (p[k]) u.searchParams.set(k, p[k]); });
    if (replace) history.replaceState({kcd: depth()}, '', u);
    else history.pushState({kcd: depth() + 1}, '', u);
    render(true);
  }
  function back(){
    if (depth() > 0) { history.back(); return; }
    var view = root.getAttribute('data-view');
    if (view !== 'buscar') { nav({q: params().get('q') || ''}, true); return; }
    var ref = document.referrer;
    try { if (ref && new URL(ref).host === location.host) { history.back(); return; } } catch(e){}
    location.href = R + '/';
  }
  q('[data-kc-back]').addEventListener('click', back);
  root.querySelectorAll('[data-kc-solicitar]').forEach(function(b){ b.addEventListener('click', function(){ nav({solicitar: '1', q: inp.value.trim()}, false); }); });
  q('[data-kc-volver]').addEventListener('click', function(){ nav({}, false); });
  window.addEventListener('popstate', function(){ render(true); });

  function render(scroll){
    var p = params();
    var view = 'buscar';
    if (p.get('solicitar')) view = 'solicitar';
    else if (p.get('m') && BYID[p.get('m')]) view = 'ficha';
    root.setAttribute('data-view', view);
    if (view === 'ficha') pintarFicha(BYID[p.get('m')]);
    else document.title = CFG.titulo;
    if (view === 'solicitar') { var rev = p.get('rev') && T.fTituloRev; var h = q('.kc-sol .kc-h1'), ip = q('.kc-sol .kc-intro'); if (h) h.textContent = rev ? T.fTituloRev : T.fTitulo; if (ip) ip.textContent = rev ? fmt(T.fIntroRev, {modelo: p.get('q') || ''}) : T.fIntro; prepararForm(p.get('q') || ''); }
    if (view === 'buscar') { var qq = p.get('q') || ''; if (inp.value !== qq) inp.value = qq; buscar(); }
    if (scroll) { var top = root.getBoundingClientRect().top + window.pageYOffset - 90; if (window.pageYOffset > top) window.scrollTo(0, Math.max(0, top)); }
  }

  /* ---------- busqueda ---------- */
  function badge(m){
    var t = m.compat === 'ok' ? 'Host · Office' : (m.compat === 'touch' ? 'Touch' : T.l.porConf);
    return '<span class="kc-badge kc-badge--' + m.compat + '">' + esc(t) + '</span>';
  }
  function card(m){
    return '<a class="kc-card" href="?m=' + encodeURIComponent(m.id) + '" data-id="' + esc(m.id) + '">' +
      '<div class="kc-card__img"><img loading="lazy" src="' + esc(fotoUrl(m)) + '" alt="' + esc(m.modelo) + '"' + IMGERR + '></div>' +
      '<div class="kc-card__body"><span class="kc-card__marca">' + esc(m.marca) + '</span>' +
      '<span class="kc-card__modelo">' + esc(m.modelo) + '</span>' +
      '<span class="kc-card__meta">' + esc(V(m.tipo)) + (m.tec ? ' · ' + esc(V(m.tec)) : '') + '</span>' + badge(m) + '</div></a>';
  }
  function buscar(){
    var raw = inp.value.trim();
    var nq = norm(raw);
    var res = q('#kc-res'), cnt = q('#kc-count');
    root.querySelectorAll('.kc-chip').forEach(function(c){ c.setAttribute('aria-pressed', norm(c.textContent) === nq ? 'true' : 'false'); });
    if (!DATA.length) return;
    if (nq.length < 1) { res.innerHTML = ''; cnt.textContent = fmt(T.cuenta, {n: DATA.length}); return; }
    var toks = nq.split(' '), compacto = nq.replace(/ /g, '');
    var out = [];
    DATA.forEach(function(m){
      var ok = toks.every(function(t){ return m._k.indexOf(t) >= 0 || m._c.indexOf(t) >= 0; }) || (compacto.length > 2 && m._c.indexOf(compacto) >= 0);
      if (!ok) return;
      var s = 0;
      if (norm(m.marca) === toks[0]) s += 2;
      if (m._c.indexOf(compacto) >= 0) s += 3;
      if (m.foto) s += 1;
      if (m.compat === 'ok') s += 0.5;
      out.push([s, m]);
    });
    out.sort(function(a, b){ return b[0] - a[0]; });
    cnt.textContent = out.length ? fmt(T.resultados, {n: out.length}) : '';
    if (!out.length) { res.innerHTML = '<div class="kc-empty">' + esc(fmt(T.sinRes, {q: raw})) + '</div>'; return; }
    res.innerHTML = out.slice(0, 80).map(function(x){ return card(x[1]); }).join('');
  }
  var tq;
  inp.addEventListener('input', function(){
    buscar();
    clearTimeout(tq);
    tq = setTimeout(function(){ var u = new URL(location.href); var v = inp.value.trim(); if (v) u.searchParams.set('q', v); else u.searchParams.delete('q'); history.replaceState({kcd: depth()}, '', u); }, 250);
  });
  root.addEventListener('click', function(e){
    var s = e.target.closest('a[data-sol]');
    if (s && !e.metaKey && !e.ctrlKey) { e.preventDefault(); nav({solicitar: '1', q: s.getAttribute('data-sol'), rev: '1'}, false); return; }
    var a = e.target.closest('a[data-id]');
    if (a && !e.metaKey && !e.ctrlKey) { e.preventDefault(); nav({m: a.getAttribute('data-id'), q: params().get('q') || inp.value.trim()}, false); return; }
    var ch = e.target.closest('.kc-chip');
    if (ch) { inp.value = ch.textContent; inp.dispatchEvent(new Event('input')); inp.focus(); }
  });

  /* ---------- parecidos ---------- */
  function numeros(s){ return (String(s || '').match(/\d{3,7}/g) || []); }
  function contiene(texto, n){ return new RegExp('(^|\\D)' + n + '(\\D|$)').test(texto); }
  var MARCAS = {};
  function porNombre(seg, o){
    var limpio = norm(seg.replace(/\([^)]*\)/g, ' '));
    var toks = limpio.split(' ').filter(function(t){ return t && !MARCAS[t]; });
    if (toks.length < 2) return false;
    var k = ' ' + o._k + ' ' + norm(o.tec);
    return toks.every(function(t){ var st = t.length > 5 ? t.slice(0, 6) : t; return k.indexOf(' ' + st) >= 0 || o._c.indexOf(t) >= 0; });
  }
  function parecidos(m){
    var directos = [], inversos = [], vistos = {};
    var segs = String(m.confunde || '').split(/[;\n]/).map(function(s){ return s.trim(); }).filter(Boolean);
    var mis = numeros(m.refs + ' ' + m.modelo);
    DATA.forEach(function(o){
      if (o.id === m.id) return;
      var hay = o.refs + ' ' + o.modelo;
      var a = segs.some(function(s){ var n = numeros(s); return n.length ? n.some(function(x){ return contiene(hay, x); }) : porNombre(s, o); });
      if (a) { vistos[o.id] = 1; directos.push(o); return; }
      if (o.confunde && mis.some(function(n){ return contiene(o.confunde, n); })) inversos.push(o);
    });
    return directos.concat(inversos.filter(function(o){ return !vistos[o.id]; })).slice(0, 4);
  }

  /* ---------- ficha ---------- */
  function compatHtml(m){
    var c = T.c;
    if (m.compat === 'ok') return '<div class="kc-compat kc-compat--ok"><p' + TIT + '>&#10003; ' + esc(c.okT) + '</p><p>' + esc(c.okX) + '</p><div class="kc-links"><a href="' + link(CFG.host) + '">' + esc(c.verHost) + ' &rarr;</a><a href="' + link(CFG.pro) + '">' + esc(c.verPro) + ' &rarr;</a></div></div>';
    if (m.compat === 'touch') return '<div class="kc-compat kc-compat--touch"><p' + TIT + '>' + esc(c.touchT) + '</p><p>' + esc(c.touchX) + '</p></div>';
    return '<div class="kc-compat kc-compat--pendiente"><p' + TIT + '>' + esc(c.penT) + '</p><p>' + esc(c.penX) + '</p><div class="kc-links"><a href="?solicitar=1&amp;q=' + encodeURIComponent(m.modelo) + '" data-sol="' + esc(m.modelo) + '">' + esc(c.penBtn) + ' &rarr;</a></div></div>';
  }
  function aper(m){ return (m.compat !== 'pendiente' && m.apertura) ? V(m.apertura) : T.l.porConf; }
  function pintarFicha(m){
    var L = T.l;
    var filas = [[L.marca, m.marca],[L.modelo, m.modelo],[L.refs, m.refs],[L.serie, m.serie],[L.tec, V(m.tec)],[L.tipo, V(m.tipo)],[L.audio, V(m.audio)],[L.apertura, aper(m)]]
      .filter(function(f){ return f[1]; })
      .map(function(f){ return '<dt>' + esc(f[0]) + '</dt><dd>' + esc(f[1]) + '</dd>'; }).join('');
    var h = '<div class="kc-f-top"><div class="kc-f-img"><img src="' + esc(fotoUrl(m)) + '" alt="' + esc(m.modelo) + '"' + IMGERR + '></div><div>' +
      '<p class="kc-f-marca">' + esc(m.marca) + (m.serie ? ' · ' + esc(m.serie) : '') + '</p><h1 class="kc-h1">' + esc(m.modelo) + '</h1>' + compatHtml(m) + '</div></div>';
    h += '<div class="kc-block"><h2 class="kc-h2">' + esc(L.datos) + '</h2><dl class="kc-dl">' + filas + '</dl></div>';
    if (m.sistema) h += '<div class="kc-block"><h2 class="kc-h2">' + esc(L.sistema) + '</h2><p class="kc-p">' + esc(m.sistema) + '</p></div>';
    if (m.bornas) h += '<div class="kc-block"><h2 class="kc-h2">' + esc(L.bornas) + '</h2><div class="kc-mono">' + esc(m.bornas) + '</div></div>';
    if (m.notas) h += '<div class="kc-block"><h2 class="kc-h2">' + esc(L.notas) + '</h2><p class="kc-p">' + esc(m.notas) + '</p></div>';
    var par = parecidos(m);
    if (m.confunde || par.length) {
      h += '<div class="kc-block"><h2 class="kc-h2" style="display:flex;align-items:center;gap:10px">' + AVISO + '<span>' + esc(T.conf.t) + '</span></h2>';
      if (par.length) {
        h += '<p class="kc-p"><strong>' + esc(T.conf.txt) + '</strong></p><div class="kc-mini" style="margin:10px 0 6px">' + par.map(card).join('') + '</div>';
        var cols = [m].concat(par);
        var row = function(lbl, fn){ return '<tr><th>' + esc(lbl) + '</th>' + cols.map(function(o){ return '<td>' + esc(fn(o)) + '</td>'; }).join('') + '</tr>'; };
        h += '<h3 class="kc-h3">' + esc(T.conf.dif) + '</h3><p class="kc-p">' + esc(T.conf.pista) + '</p><div class="kc-cmp-wrap"><table class="kc-cmp"><thead><tr><th></th>' +
          cols.map(function(o, i){ return '<th>' + (i === 0 ? esc(T.conf.este) + '<br>' + esc(o.modelo) : '<a href="?m=' + encodeURIComponent(o.id) + '" data-id="' + esc(o.id) + '">' + esc(o.modelo) + '</a>') + '</th>'; }).join('') + '</tr></thead><tbody>' +
          row(L.refs, function(o){ return o.refs; }) + row(L.serie, function(o){ return o.serie; }) + row(L.tec, function(o){ return V(o.tec); }) + row(L.bornas, function(o){ return o.bornas; }) + row(L.apertura, aper) + row(T.conf.compat, function(o){ return o.compat === 'ok' ? 'Host · Office' : (o.compat === 'touch' ? 'Touch' : T.l.porConf); }) +
          '</tbody></table></div>';
      } else {
        h += '<p class="kc-p"><strong>' + esc(T.conf.txt) + '</strong> ' + esc(m.confunde) + '</p>';
      }
      h += '</div>';
    }
    h += '<div class="kc-asis"><h2 class="kc-h2">' + esc(T.asis.t) + '</h2><p class="kc-p">' + esc(T.asis.x) + '</p><div class="kc-actions">' +
      '<span class="kc-wip"><button type="button" class="kc-btn" disabled aria-disabled="true">' + esc(T.asis.dist) + '</button><small>' + esc(T.asis.obras) + '</small></span>' +
      '<a class="kc-btn kc-btn--line" href="' + link(CFG.contact) + '">' + esc(T.asis.form) + '</a></div></div>';
    q('#kc-ficha').innerHTML = h;
    document.title = m.modelo + ' · ' + T.titulo;
  }

  /* ---------- solicitud ---------- */
  var form = q('#kc-form'), msg = q('#kc-msg'), thumbs = q('#kc-thumbs'), fileIn = q('#kc-file');
  function prepararForm(txt){
    q('#kc-ok').hidden = true; form.hidden = false; msg.textContent = '';
    if (txt && !form.modelo.value && !form.marca.value) {
      var partes = txt.split(/\s+/);
      var mk = MARCAS[norm(partes[0])];
      if (mk) { form.marca.value = mk; form.modelo.value = partes.slice(1).join(' '); }
      else form.modelo.value = txt;
    }
  }
  function reducir(file){
    return new Promise(function(ok, ko){
      var url = URL.createObjectURL(file), img = new Image();
      img.onload = function(){
        var s = Math.min(1, 1600 / Math.max(img.width, img.height));
        var c = document.createElement('canvas'); c.width = Math.round(img.width * s); c.height = Math.round(img.height * s);
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
        URL.revokeObjectURL(url); ok(c.toDataURL('image/jpeg', 0.82));
      };
      img.onerror = function(){ URL.revokeObjectURL(url); ko(); };
      img.src = url;
    });
  }
  function pintarThumbs(){
    thumbs.innerHTML = FOTOS.map(function(d, i){ return '<div class="kc-thumb"><img src="' + d + '" alt=""><button type="button" data-del="' + i + '" aria-label="' + esc(T.quitar) + '">&times;</button></div>'; }).join('');
  }
  fileIn.addEventListener('change', function(){
    var files = Array.prototype.slice.call(fileIn.files || []);
    fileIn.value = '';
    msg.textContent = '';
    if (FOTOS.length + files.length > 6) { msg.textContent = T.fMax; files = files.slice(0, Math.max(0, 6 - FOTOS.length)); }
    Promise.all(files.map(function(f){ return reducir(f).catch(function(){ return null; }); })).then(function(r){ r.forEach(function(d){ if (d) FOTOS.push(d); }); pintarThumbs(); });
  });
  thumbs.addEventListener('click', function(e){ var b = e.target.closest('[data-del]'); if (b) { FOTOS.splice(+b.getAttribute('data-del'), 1); pintarThumbs(); } });
  form.addEventListener('submit', function(e){
    e.preventDefault();
    var f = form;
    var marca = f.marca.value.trim(), modelo = f.modelo.value.trim(), email = f.email.value.trim();
    if ((!marca && !modelo) || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email) || !f.priv.checked) { msg.textContent = T.fFalta; return; }
    var btn = f.querySelector('[type=submit]');
    btn.disabled = true; btn.textContent = T.fEnviando; msg.textContent = '';
    var datos = { marca: marca, modelo: modelo, obs: f.obs.value.trim(), nombre: f.nombre.value.trim(), email: email, web: f.web.value, idioma: CFG.lang, origen: (params().get('q') || '') + ' | ' + location.pathname, fotos: FOTOS };
    fetch(CFG.endpoint, { method: 'POST', body: JSON.stringify(datos) })
      .then(function(r){ return r.json(); })
      .then(function(j){
        if (!j || !j.ok) throw new Error((j && j.error) || 'error');
        form.reset(); FOTOS = []; pintarThumbs();
        form.hidden = true; q('#kc-ok').hidden = false;
      })
      .catch(function(){ msg.textContent = T.fErr; })
      .then(function(){ btn.disabled = false; btn.textContent = T.fEnviar; });
  });

  /* ---------- carga ---------- */
  q('#kc-count').textContent = T.cargando;
  fetch(CFG.json).then(function(r){ return r.json(); }).then(function(d){
    DATA = (d.modelos || d).map(function(m){
      var k = [m.marca, m.modelo, m.serie, m.refs].join(' ');
      m._k = norm(k); m._c = m._k.replace(/ /g, '');
      BYID[m.id] = m; return m;
    });
    var cuenta = {};
    DATA.forEach(function(m){ cuenta[m.marca] = (cuenta[m.marca] || 0) + 1; norm(m.marca).split(' ').forEach(function(t){ if (!MARCAS[t]) MARCAS[t] = m.marca; }); });
    q('#kc-chips').innerHTML = Object.keys(cuenta).sort(function(a, b){ return cuenta[b] - cuenta[a]; }).slice(0, 10)
      .map(function(b){ return '<button type="button" class="kc-chip" aria-pressed="false">' + esc(b) + '</button>'; }).join('');
    render(false);
  }).catch(function(){ q('#kc-count').textContent = T.errorCarga; });
})();
